import { listMenu } from "../../../stores/ListMenu";

export const getDashboardOptionsWithMenuLabel = async () => {
  const menuStore = listMenu();

  if (!menuStore.menuPhanCap || menuStore.menuPhanCap.length === 0) {
    await menuStore.getListMenuPhanCap();
  }

  // Lọc chỉ lấy menu có targetType === "dynamic" và map thành options
  const options = menuStore.menuPhanCap
    .filter((item) => item.targetType === "dynamic" && item.targetId)
    .map((item) => ({
      value: item.targetId,
      label: item.label,
    }));

  return options;
};
